var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{attrs:{"light":""}},[_c('Header',{staticClass:"hidden-sm-and-down"}),_c('HeaderMobile',{staticClass:"hidden-md-and-up"}),_c('Datenschutz',{attrs:{"id":"datenschutz"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }